import React from "react";
import Banner from "../components/Banner";
import Counter from "../components/Counter";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Launchpad from "../components/Launchpad";
import Newsletter from "../components/Newsletter";
import PastLaunches from "../components/Pastlaunches";

const HomePage = () => {
	return (
		<>
			<Header />
			<Banner />
			{/* <Counter /> */}
			<Launchpad />

			<PastLaunches />
			<br></br>
			<Footer />
		</>
	);
};

export default HomePage;
